import { useEffect, useState } from "react";
import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  VStack,
  Spinner,
  useToast,
  FormControl,
  FormLabel,
  Switch,
  Checkbox,
} from "@chakra-ui/react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo.png";
import useLogin from "api/mutations/useLogin";
import FormikInput from "components/formikInput";
import kidsImage from "../../assets/register-image-kids.png";
import { useUserContext } from "context/UserContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { signIn } = useUserContext();
  const [isLoginDisabled, setIsLoginDisabled] = useState(true);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required("Email cannot be empty"),
      password: Yup.string().required("Password cannot be empty"),
      rememberMe: Yup.boolean().required("Select an option for remember me"),
    }),
    onSubmit: (values) => handleLogin(values),
  });

  useEffect(() => {
    if (!(formik.values.email && formik.values.password)) {
      setIsLoginDisabled(true);
      return;
    }
    setIsLoginDisabled(false);
  }, [formik.values]);

  const loginMutation = useLogin({
    onSuccess: (res) => {
      console.log('response', res);
      if (res.status === 200) {
        localStorage.setItem("token", res.data.token);
        signIn(res.data);
        navigate("/dashboard");
      }
    },
    onError: (err) => {
      const response = err.response;
      toast({
        title: "Failed to log in",
        description: response?.data?.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  // const handleRegister = () => {
  //   navigate("/register");
  // };

  const handleLogin = async (values) => {
    try {
      const data = {
        email: values.email,
        password: values.password,
        role: "seller",
      };
      loginMutation.mutate(data);
    } catch (e) {
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={5} width={400}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Login
          </Text>
          {/* <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontSize={"16px"}
            lineHeight={"28px"}
            textAlign={"center"}
            color={"#898989"}
          >
            Start your journey with KWC
          </Text> */}
          <VStack align="flex-center" spacing={6}>
            <FormikInput
              name="email"
              type="text"
              label="Email Address"
              placeholder={"Enter Your Email Address"}
              formik={formik}
            />
            <FormikInput
              name="password"
              label="Password"
              placeholder={"Enter Your Password"}
              isPassword={true}
              formik={formik}
            />
            <VStack display={"flex"}>
              <FormControl
                display="flex"
                alignItems="center"
                // justifyContent=""
                gap={2}
              >
                <Checkbox />
                <FormLabel
                  htmlFor="remember-me"
                  mb="0"
                  color={"#00000"}
                  fontFamily={"PlusJakartaSansMedium"}
                  textTransform={"capitalize"}
                  fontSize={"12px"}
                >
                  Remember Me
                </FormLabel>
                <VStack flex={1}>
                  <Button
                    alignSelf={"flex-end"}
                    onClick={() => navigate("/forgot-password")}
                    bg={"transparent"}
                    fontSize={12}
                    _hover={{
                      bg: "transparent",
                    }}
                    padding={0}
                    margin={0}
                  >
                    <Text
                      color={"#456EFF"}
                      fontSize={"12px"}
                      fontFamily={"PlusJakartaSansSemiBold"}
                    >
                      Forgot your password?
                    </Text>
                  </Button>
                </VStack>
              </FormControl>
            </VStack>
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"48px"}
              onClick={formik.handleSubmit}
              isDisabled={isLoginDisabled || loginMutation.isLoading}
              _hover={{
                bg: "#456EFF",
                color: "#FFFFFF",
              }}
            >
              {loginMutation.isLoading ? <Spinner /> : "Continue"}
            </Button>
          </VStack>
          {/* <Flex justifyContent={"center"} alignItems={"center"} gap={1}>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#000000"}
            >
              Don’t have an account?
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#456EFF"}
              cursor={"pointer"}
              textDecoration={"underline"}
              onClick={handleRegister}
            >
              Sign Up
            </Text>
          </Flex> */}
        </VStack>
      </Box>
      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default LoginPage;
